import {
  RegisterCustomerRequestedAction,
  registerCustomerFailed,
  registerCustomerSucceeded
} from '@spa/lib/store/auth/authSlice';
import { call, put } from 'typed-redux-saga';
import registerCustomerAction, {
  RegisterCustomerActionInput
} from '@spa/lib/actions/auth/registerCustomerAction';
import {
  trackRegisterError,
  trackSuccessfulRegister
} from '@spa/components/register/register-tracking';
import { CreateMeResult } from '@spa/lib/graphql/me/createMe';
import { CreateMeStatus } from '@spa/generated/graphql/graphql';
import { RegisterFailedCause } from '@spa/lib/store/auth/RegisterFailedCause';
import generateActionId from '@spa/lib/generateActionId';
import isErrorStatus from '@spa/components/register/isErrorStatus';
import logger from '@spa/lib/logger';
import { select } from 'typed-redux-saga';
import selectSessionUserId from '@spa/lib/store/session/selectors/selectSessionUserId';

function* registerCustomerSaga({
  payload: {
    actionId: requestedActionId,
    firstName,
    lastName,
    email,
    titleCode,
    password,
    phoneNumber
  }
}: RegisterCustomerRequestedAction): Generator {
  let cause: RegisterFailedCause | null = null;

  const anonymousUserId: string = yield* select(selectSessionUserId);
  try {
    const input: RegisterCustomerActionInput = {
      firstName,
      lastName,
      email,
      titleCode,
      password,
      phoneNumber
    };
    const { me, message, status }: CreateMeResult = yield* call(
      registerCustomerAction,
      'registerCustomerAction',
      input
    );
    if (isErrorStatus(status)) {
      logger.error(`Error: ${status}. ${message}`);
      trackRegisterError(status, anonymousUserId);
      cause =
        status === CreateMeStatus.EMAIL_IN_USE
          ? RegisterFailedCause.EMAIL_IN_USE
          : RegisterFailedCause.UNKNOWN_ERROR;
    } else if (me) {
      trackSuccessfulRegister(me.id, anonymousUserId);
    } else {
      cause = RegisterFailedCause.UNKNOWN_ERROR;
    }
  } catch {
    cause = RegisterFailedCause.UNKNOWN_ERROR;
  }

  const actionId: number = generateActionId();
  if (cause === null) {
    yield* put(
      registerCustomerSucceeded({
        actionId,
        requestedActionId
      })
    );
  } else {
    yield* put(
      registerCustomerFailed({
        actionId,
        requestedActionId,
        cause
      })
    );
  }
}

export default registerCustomerSaga;
